import "../scss/main.scss";

document.addEventListener("DOMContentLoaded", function (event) {
    const menu = document.querySelector(".menu");
    const menuMain = menu.querySelector(".menu-main");
    const goBack = menu.querySelector(".go-back");
    const menuTrigger = document.querySelector(".mobile-menu-trigger");
    const closeMenu = menu.querySelector(".mobile-menu-close");
    let subMenu;
    menuMain.addEventListener("click", (e) => {
        if (!menu.classList.contains("active")) {
            return;
        }
        if (e.target.closest(".menu-item-has-children")) {
            const hasChildren = e.target.closest(".menu-item-has-children");
            showSubMenu(hasChildren);
        }
    });
    goBack.addEventListener("click", () => {
        hideSubMenu();
    });
    menuTrigger.addEventListener("click", () => {
        toggleMenu();
    });
    closeMenu.addEventListener("click", () => {
        toggleMenu();
    });
    document.querySelector(".menu-overlay").addEventListener("click", () => {
        toggleMenu();
    });
    function toggleMenu() {
        menu.classList.toggle("active");
        document.querySelector(".menu-overlay").classList.toggle("active");
    }
    function showSubMenu(hasChildren) {
        subMenu = hasChildren.querySelector(".sub-menu");
        subMenu.classList.add("active");
        subMenu.style.animation = "slideLeft 0.5s ease forwards";
        const menuTitle =
            hasChildren.querySelector("i").parentNode.childNodes[0].textContent;
        menu.querySelector(".current-menu-title").innerHTML = menuTitle;
        menu.querySelector(".mobile-menu-head").classList.add("active");
    }

    function hideSubMenu() {
        subMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
            subMenu.classList.remove("active");
        }, 300);
        menu.querySelector(".current-menu-title").innerHTML = "";
        menu.querySelector(".mobile-menu-head").classList.remove("active");
    }

    window.onresize = function () {
        if (this.innerWidth > 991) {
            if (menu.classList.contains("active")) {
                toggleMenu();
            }
        }
    };

    if (
        document.getElementById("standings-button") &&
        document.getElementById("program-button") &&
        document.getElementById("results-button")
    ) {
        document
            .getElementById("standings-button")
            .addEventListener("click", (e) => tabsSelect("standings-wrapper"));
        document
            .getElementById("program-button")
            .addEventListener("click", (e) => tabsSelect("program-wrapper"));
        document
            .getElementById("results-button")
            .addEventListener("click", (e) => tabsSelect("results-wrapper"));
    }

    // Lightbox Gallery

    // query selectors
    const lightboxEnabled = document.querySelectorAll(".lightbox-enabled");
    const lightboxEnabledOverlays = document.querySelectorAll(".single-img");
    const lightboxArray = Array.from(lightboxEnabled);
    const lastImage = lightboxArray.length - 1;
    const lightboxContainer = document.querySelector(".lightbox-container");
    const lightboxImage = document.querySelector(".lightbox-image");
    const lightboxBtns = document.querySelectorAll(".lightbox-btn");
    const lightboxBtnRight = document.querySelector("#right");
    const lightboxBtnLeft = document.querySelector("#left");
    const close = document.querySelector("#close");
    let activeImage;
    // Functions
    const showLightBox = () => {
        lightboxContainer.classList.add("active");
    };

    const hideLightBox = () => {
        lightboxContainer.classList.remove("active");
    };

    const setActiveImage = (image) => {
        lightboxImage.src = image.dataset.imgsrc;
        activeImage = lightboxArray.indexOf(image);
    };

    const transitionSlidesLeft = () => {
        lightboxBtnLeft.focus();
        document.querySelector(".lightbox-image").classList.add("slideright");
        setTimeout(function () {
            activeImage === 0
                ? setActiveImage(lightboxArray[lastImage])
                : setActiveImage(lightboxArray[activeImage - 1]);
        }, 250);

        setTimeout(function () {
            document
                .querySelector(".lightbox-image")
                .classList.remove("slideright");
        }, 500);
    };

    const transitionSlidesRight = () => {
        lightboxBtnRight.focus();
        document.querySelector(".lightbox-image").classList.add("slideleft");
        setTimeout(function () {
            activeImage === lastImage
                ? setActiveImage(lightboxArray[0])
                : setActiveImage(lightboxArray[activeImage + 1]);
        }, 250);
        setTimeout(function () {
            document
                .querySelector(".lightbox-image")
                .classList.remove("slideleft");
        }, 500);
    };

    const transitionSlideHandler = (moveItem) => {
        moveItem.includes("left")
            ? transitionSlidesLeft()
            : transitionSlidesRight();
    };

    // Event Listeners
    lightboxEnabled.forEach((image) => {
        image.addEventListener("click", (e) => {
            showLightBox();
            setActiveImage(image);
        });
    });
    lightboxEnabledOverlays.forEach((image) => {
        image.addEventListener("click", (e) => {
            showLightBox();
            setActiveImage(image.children[0]);
        });
    });
    if (lightboxContainer != null) {
        lightboxContainer.addEventListener("click", () => {
            hideLightBox();
        });
    }
    if (close != null) {
        close.addEventListener("click", () => {
            hideLightBox();
        });
    }
    lightboxBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            transitionSlideHandler(e.currentTarget.id);
        });
    });
    if (lightboxImage != null) {
        lightboxImage.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }
});

function tabsSelect(tabSelected) {
    const standings = document.getElementById("standings-wrapper");
    const program = document.getElementById("program-wrapper");
    const results = document.getElementById("results-wrapper");

    const standingsButton = document.getElementById("standings-button");
    const programButton = document.getElementById("program-button");
    const resultsButton = document.getElementById("results-button");

    if (standings.id == tabSelected) {
        standings.classList.remove("hidden");
        program.classList.add("hidden");
        results.classList.add("hidden");

        standingsButton.classList.add("active");
        programButton.classList.remove("active");
        resultsButton.classList.remove("active");
    } else if (program.id == tabSelected) {
        standings.classList.add("hidden");
        program.classList.remove("hidden");
        results.classList.add("hidden");

        standingsButton.classList.remove("active");
        programButton.classList.add("active");
        resultsButton.classList.remove("active");
    } else if (results.id == tabSelected) {
        standings.classList.add("hidden");
        program.classList.add("hidden");
        results.classList.remove("hidden");

        standingsButton.classList.remove("active");
        programButton.classList.remove("active");
        resultsButton.classList.add("active");
    } else {
        standings.classList.remove("hidden");
        program.classList.add("hidden");
        results.classList.add("hidden");

        standingsButton.classList.add("active");
        programButton.classList.remove("active");
        resultsButton.classList.remove("active");
    }
}
